var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatCurrency"},[_vm._v(" "+_vm._s(_vm.displayValue)+" "),(_vm.floatCurrency !== null)?[_vm._v(_vm._s(_vm.floatCurrency))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }